<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 14:53:59
 * @Description: 添加评估成员
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-40 o-dialog--lg-40 o-dialog--xl-40 o-dialog-h--55"
    title="添加评估成员"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="100px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="姓名"
              prop="xmCodeList"
            >
              <el-checkbox-group
                v-model="fd.xmCodeList"
                class="c-form__checkbox-group"
              >
                <el-checkbox
                  v-for="item in pgcyXmList"
                  :key="item.capacityCode"
                  class="o-check"
                  :label="item.capacityCode"
                >
                  {{ item.capacityName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { pgcyService } from './pgcy.service.js';
export default {
  name: 'AddPgcyDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      xmid: null,
      /* 表单参数 Start */
      fd: {
        xmCodeList: []
      },
      roleCode: 'PGRY',
      pgcyXmList: [],
      /* 表单参数 End */
      /* 表单校验规则 Start */
      fdRules: {
        xmCodeList: [this.$validUtils.required('姓名')]
      }
      /* 表单校验规则 End */
    };
  },

  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init () {
      const currentUser = this.$HMStoreService.getUserinfo();
      const params = {
        deptCode: currentUser ? currentUser.dept.deptCode : this.deptCode
      };
      this.$axios.get(`${this.$config.commontCtx}/roleCapacity/role/${this.roleCode}/capacities`, { params: params })
        .then(rsp => {
          this.pgcyXmList = rsp.data;
        })
        .catch(err => {
          console.error('获取评估人员信息失败!', err);
        });

      this.fd.xmCodeList = [];
      pgcyService.pgcyQuery(this.xmid, null)
        .then(rsp => {
          rsp.data.forEach(e => {
            this.fd.xmCodeList.push(e.cyId);
          });
        })
        .catch(err => {
          console.error('获取评估成员信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
      console.log(this.fd.xmCodeList);
    },
    /**
     * 保存
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.addSave();
        }
      });
    },
    /**
     * @description: 添加评估成员
     * @return {*}
     */
    addSave () {
      this.loading = true;
      pgcyService.addPgcy(this.xmid, this.fd.xmCodeList)
        .then(rsp => {
          this.$message({
            message: '添加成功！',
            type: 'success'
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('添加评估成员错误！', err);
          this.loading = false;
        });
    }

  },
  created () {
    this.xmid = this.dlParams.id;
    this.init();
  }
};

</script>
<style scoped>
.o-check{
  padding: 10px;
}
</style>
